const isSitecoreTruthy = param => {
  if (typeof param === 'string') {
    return !!param && param.toLowerCase() !== 'false' && param !== '0';
  }
  return !!param;
};

export default isSitecoreTruthy;
